import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eua',
  templateUrl: './eua.component.html',
  styleUrls: ['./eua.component.scss']
})
export class EuaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
